export default
{
    listCargas: "/lavanderia/listCargas",
}